module.exports = __webpack_public_path__ + "static/media/aw.a7c647c3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/aw.svg
// module id = 2039
// module chunks = 0